module.exports = __webpack_public_path__ + "files/5ee9275a0e1b5893a8a6c01ca1e89b45.png";